import { render } from "./NoteColloFields.vue?vue&type=template&id=01c2242a"
import script from "./NoteColloFields.vue?vue&type=script&lang=js"
export * from "./NoteColloFields.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__